var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFlagCanadamin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M2.667 0A2.667 2.667 0 0 0 0 2.667v12a2.667 2.667 0 0 0 2.667 2.666h4V0h-4Zm18.666 0h-4v17.333h4A2.667 2.667 0 0 0 24 14.667v-12A2.667 2.667 0 0 0 21.333 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.667 0h10.666v17.333H6.667V0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M12.41 11.409c.799.092 1.515.176 2.313.267l-.204-.668a.306.306 0 0 1 .106-.317l2.32-1.89-.48-.226c-.212-.075-.154-.194-.077-.481l.354-1.29-1.347.284c-.132.02-.219-.063-.239-.143l-.174-.608-1.065 1.196c-.152.192-.458.192-.363-.25l.455-2.423-.611.317c-.171.096-.343.112-.438-.06l-.843-1.577v.04-.04l-.844 1.577c-.096.172-.267.156-.438.06l-.611-.317.455 2.423c.096.442-.211.442-.362.25L9.25 6.338l-.173.607c-.02.08-.108.164-.24.144l-1.347-.285.354 1.29c.076.287.134.407-.077.482l-.48.226 2.32 1.89c.091.07.138.2.105.317l-.204.668 2.314-.268c.07 0 .117.04.116.121L11.797 14h.637l-.142-2.47c.001-.082.047-.121.118-.121Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFlagCanadamin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_flag_canada.min.141bf38d470b49d096a023aea96d25e8.svg";